import { Link } from "react-router-dom";
import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { statsData, testimonials } from "@/mocks/comics";
import { faqs } from "@/mocks/comics-detail";

function ContactForm() {
  const [formState, setFormState] = useState({ name: "", email: "", message: "" });
  const [submitStatus, setSubmitStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus("submitting");

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get("company_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setSubmitStatus("success");
      setStatusMsg("消息已发送！我们会尽快回复您。");
      setFormState({ name: "", email: "", message: "" });
      return;
    }

    try {
      const res = await fetch("http://xv8g8.cn/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          name: formData.get("name") as string,
          email: formData.get("email") as string,
          message: formData.get("message") as string,
        }).toString(),
      });
      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === "OK") {
        setSubmitStatus("success");
        setStatusMsg("消息已发送！我们会尽快回复您。");
        setFormState({ name: "", email: "", message: "" });
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || "发送失败，请稍后再试。";
        setSubmitStatus("error");
        setStatusMsg(errMsg);
      }
    } catch {
      setSubmitStatus("error");
      setStatusMsg("网络错误，请检查连接后重试。");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">您的名字</label>
        <input
          id="contact-name"
          type="text"
          name="name"
          value={formState.name}
          onChange={(e) => setFormState({ ...formState, name: e.target.value })}
          required
          className="w-full px-4 py-3 text-sm border border-background-300 rounded-xl bg-background-50 focus:border-primary-500 outline-none transition-colors"
          placeholder="请输入您的名字"
        />
      </div>
      <div>
        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱地址</label>
        <input
          id="contact-email"
          type="email"
          name="email"
          value={formState.email}
          onChange={(e) => setFormState({ ...formState, email: e.target.value })}
          required
          className="w-full px-4 py-3 text-sm border border-background-300 rounded-xl bg-background-50 focus:border-primary-500 outline-none transition-colors"
          placeholder="请输入您的邮箱"
        />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
        <textarea
          id="contact-message"
          name="message"
          value={formState.message}
          onChange={(e) => setFormState({ ...formState, message: e.target.value })}
          required
          maxLength={500}
          rows={4}
          className="w-full px-4 py-3 text-sm border border-background-300 rounded-xl bg-background-50 focus:border-primary-500 outline-none transition-colors resize-none"
          placeholder="请输入您的留言（最多500字）"
        ></textarea>
        <p className="text-xs text-foreground-400 mt-1">{formState.message.length}/500</p>
      </div>
      <input
        type="text"
        name="company_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="absolute opacity-0 pointer-events-none w-0 h-0"
        style={{ position: 'absolute', left: '-9999px' }}
      />
      <button
        type="submit"
        disabled={submitStatus === "submitting"}
        className="w-full py-3 bg-foreground-950 text-white rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
      >
        {submitStatus === "submitting" ? "发送中..." : "发送消息"}
      </button>
      {submitStatus !== "idle" && (
        <p className={`text-sm text-center ${submitStatus === "success" ? "text-emerald-600" : "text-red-500"}`}>
          {statusMsg}
        </p>
      )}
    </form>
  );
}

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-20">
        <nav aria-label="面包屑导航" className="px-6 md:px-10 py-4">
          <ol className="flex items-center gap-2 text-sm text-foreground-500">
            <li><Link to="/" className="hover:text-foreground-900 transition-colors">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li><span className="text-foreground-900 font-medium">关于我们</span></li>
          </ol>
        </nav>

        <section className="px-6 md:px-10 py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h1 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                关于韩漫屋
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                韩漫屋成立于2020年，是国内领先的免费正版韩国漫画在线阅读平台。我们汇聚了海量优质韩漫资源，涵盖恋爱、校园、奇幻、武侠、都市等多元题材，致力于为每一位漫画爱好者提供高品质的阅读体验。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
              {statsData.map((stat) => (
                <div key={stat.label} className="text-center p-6 rounded-2xl bg-background-100">
                  <p className="text-3xl md:text-4xl font-bold text-foreground-950 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-6 md:px-10 py-10 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
                我们的承诺
              </h2>
              <p className="text-sm text-foreground-500">用心做好每一个细节，为你打造极致的漫画阅读体验</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-accent-100 text-accent-600 flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">正版授权</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">所有漫画均获得正版授权，支持原创作者，保障读者权益，让阅读更安心。</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center mb-4">
                  <i className="ri-flashlight-line text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">极速更新</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">每日同步更新热门韩漫，第一时间为你带来最新章节，追更不等待。</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-emerald-100 text-emerald-600 flex items-center justify-center mb-4">
                  <i className="ri-shining-2-line text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">优质体验</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">高清画质、流畅翻页、智能推荐，多设备无缝切换，让阅读成为一种享受。</p>
              </div>
            </div>
          </div>
        </section>

        <section className="px-6 md:px-10 py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
                读者口碑
              </h2>
              <p className="text-sm text-foreground-500">来自百万读者的真实评价</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.slice(0, 3).map((t) => (
                <div key={t.id} className="p-5 rounded-2xl bg-background-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.username}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">&ldquo;{t.comment}&rdquo;</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-6 md:px-10 py-10 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: "var(--font-heading)" }}>
                  联系我们
                </h2>
                <div className="space-y-4 mb-8">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-background-50 border border-background-200 flex items-center justify-center">
                      <i className="ri-mail-line text-lg text-foreground-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">邮箱</p>
                      <p className="text-sm text-foreground-800">hello@xv8g8.cn</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-background-50 border border-background-200 flex items-center justify-center">
                      <i className="ri-customer-service-2-line text-lg text-foreground-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">客服支持</p>
                      <p className="text-sm text-foreground-800">工作日 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                <h3 className="text-lg font-semibold text-foreground-950 mb-4">常见问题</h3>
                <div className="space-y-3">
                  {faqs.map((faq, idx) => (
                    <details key={idx} className="group">
                      <summary className="text-sm font-medium text-foreground-800 cursor-pointer py-2 hover:text-foreground-950 transition-colors list-none flex items-center justify-between">
                        {faq.question}
                        <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                      </summary>
                      <p className="text-sm text-foreground-600 leading-relaxed pt-2 pb-3">{faq.answer}</p>
                    </details>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: "var(--font-heading)" }}>
                  给我们留言
                </h2>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}